import React from "react";
import { useSector } from "./SectorContext";
import { useNavigate } from "react-router-dom";
import useReveal from "./hooks/useReveal";


function ContactSection() {
  const { activeSector } = useSector();
  const navigate = useNavigate();

  useReveal()

  return (
    <section className="contact-section">
      <div className="contact-container ">
        <h2 className={`contact-hook ${activeSector.colorClass}`}>
          {activeSector.contactContent.contactHook[0]}
        </h2>

        <p className="contact-description"data-reveal>
          {activeSector.contactContent.contactDescription}
        </p>
        <button
          className="contact-button shiny-border"
          onClick={() => navigate("/contact")}
        >
          Let's Connect
        </button>
      </div>
    </section>
  );
}

export default ContactSection;
